import { useEffect, useRef, useState } from 'react';
import { useOutsideClick } from 'hooks';
import classNames from 'classnames';
import moment from 'moment';

import { Popover } from 'components-antd';
import { CalendarView } from 'pages/Calendar/constants';
import { NavButtonRight, NavButtonLeft } from '../NavButtons';

import styles from './styles.module.scss';

const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const MonthYearPopover = ({ currentDate, view, setCurrentDate, isOverdueMilestones }) => {
  const popoverReference = useRef<any>();
  const [selectedYear, setSelectedYear] = useState(currentDate.year());
  const [visible, setVisible] = useState(false);

  const isDayView = view === CalendarView.DAY;

  useEffect(() => {
    if (visible) setSelectedYear(currentDate.year());
  }, [visible]);

  useOutsideClick([popoverReference], () => {
    setVisible(false);
  });

  const handleMonthClick = (monthIndex) => {
    setCurrentDate(moment().year(selectedYear).month(monthIndex));
    setVisible(false);
  };

  return (
    <Popover
      open={visible}
      placement="bottom"
      content={
        <div ref={popoverReference} className={styles.monthsYearsContent}>
          <div>
            <div className={styles.yearContainer}>
              <NavButtonLeft
                handlePrev={() => setSelectedYear(selectedYear - 1)}
                className={styles.arrowLeft}
              />
              <p className={styles.selectedYearText}>{selectedYear}</p>
              <NavButtonRight
                handleNext={() => setSelectedYear(selectedYear + 1)}
                className={styles.arrowRight}
              />
            </div>
            <div className={styles.monthsContent}>
              {months.map((month, index) => (
                <div
                  key={index}
                  className={classNames(styles.monthBtn, {
                    [styles.active]:
                      selectedYear === currentDate.year() && index === currentDate.month(),
                  })}
                  onClick={() => handleMonthClick(index)}
                >
                  {month}
                </div>
              ))}
            </div>
          </div>
        </div>
      }
      overlayClassName={styles.monthYearPopover}
    >
      <div
        className={classNames(styles.dateDisplayContainer, { [styles.cursorUnset]: isDayView })}
        onClick={() => !isDayView && setVisible((val) => !val)}
      >
        <h2 className={styles.title}>
          {isOverdueMilestones
            ? 'Overdue Milestones'
            : currentDate.format(isDayView ? 'MMMM D, YYYY' : 'MMMM YYYY')}
        </h2>
      </div>
    </Popover>
  );
};
